import * as React from 'react';
import { Link } from 'react-router-dom';
import { Divider, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';
import { Person as PersonIcon, Favorite as FavoriteIcon, GroupWork as OrganizationIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ProfileAvatar from '../../ProfileAvatar';
import LogoutButton from '../../LogoutButton';

export default function AccountMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip>
        <IconButton onClick={handleClick} size="small">
          <ProfileAvatar />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="AccountMenu"
        data-testid="AccountMenu"
        open={open}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem component={Link} to="/profile">
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          {t('navigation.accountMenu.items.profile')}
        </MenuItem>
        <MenuItem component={Link} to="/profile/favorites">
          <ListItemIcon>
            <FavoriteIcon fontSize="small" />
          </ListItemIcon>
          {t('navigation.accountMenu.items.favorites')}
        </MenuItem>
        <MenuItem component={Link} to="/profile/organizations">
          <ListItemIcon>
            <OrganizationIcon fontSize="small" />
          </ListItemIcon>
          {t('navigation.accountMenu.items.organizations')}
        </MenuItem>
        <Divider />
        <LogoutButton />
      </Menu>
    </>
  );
}
